import { ApiResponse, getRequest } from "@/data/apiClient";

export interface Link {
  url: string;
  title: string;
  iconName?: string;
}

export const getLinks = async (userId: number): Promise<ApiResponse<Link[]>> =>
  getRequest("/user/links", { userId });
